module.exports = __webpack_public_path__ + "img/move-puce-full.90bf6d3e.jpg";